module.exports = __webpack_public_path__ + "1f656347cead3a1912e42b33236fb28a.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/history/9.jpg
// module id = 527
// module chunks = 0